<script>
import resources from './resources'

export default {
  name: 'professional-graduations',
  mixins: [resources]
}
</script>

<template lang="pug">
  .row.border-top(style="margin-bottom: 20px;")
    .col-xs-12.col-sm-4.margin-bottom
      small.grey Graduação
      br
      span#professionalName.blue(style="font-size: 15px;") {{ graduation.label }}

    .col-xs-12.col-sm-6.margin-bottom
      small.grey Instituição de Ensino
      br
      span#professionalName.blue(style="font-size: 15px;") {{ graduation.entity }}

    .col-xs-12.col-sm-2.margin-bottom
      small.grey Ano
      br
      span#professionalName.blue(style="font-size: 15px;") {{ graduation.year }}
</template>
<style scoped>
.grey {
  color: #93959b;
  font-weight: bold;
  font-size: 12px;
}
.blue {
    color: #2071b9;
    font-size: 1.2em;
    font-weight: 700;
    display: block;
}
.small {
    font-size: 90%;
}
</style>



// WEBPACK FOOTER //
// src/app/patient/profile-company-professional/components/graduations/graduations.vue